import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudtrailService } from '../../service';

export type TrailEnabledConfig = typeof TrailEnabledConfig._.Config;

export const TrailEnabledConfig = IntegrationConfig.make({
  service: CloudtrailService,
  name: Integration_Handler_Names_Enum.TrailEnabled,
  configSchema: z.object({}),
});
